import { connect } from 'react-redux'
import ServiceSetup from './ServiceSetup'

import * as fromBookingSetup from '@src/redux/modules/bookingSetup'
import { getUsers } from '@src/redux/modules/entities'
import * as qs from 'utils/querystring'

const mapStateToProps = (state, ownProps) => {
  let { step } = qs.parse(ownProps.location.search)
  step = Number(step)

  const { userId } = ownProps.params
  const users = getUsers(state)
  const user = users[userId]

  return {
    currentStep: step || fromBookingSetup.getCurrentStep(state),
    shouldReturnToSearch: !isNaN(step),
    setup: fromBookingSetup.getSetup(state),
    setupHasBeenEdited: fromBookingSetup.isEdited(state),
    user
  }
}

const mapDispatchToProps = {
  update: fromBookingSetup.update,
  nextStep: fromBookingSetup.nextStep,
  finish: fromBookingSetup.finish
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceSetup)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/ServiceSetupContainer.js